export default "assets/images/texture-dc4e1e73.jpg";